import './ChemelexUiToggle.scss';
import React from 'react';
import { useSelector } from 'react-redux';
import FormGroup from '@mui/material/FormGroup';
import Switch from '@mui/material/Switch';

import {
  hasChemelexUiFeature,
  getUseChemelexUiPreference
} from 'src/module/authentication/chemelexUi.selector';
import useSwitchChemelexUi from 'src/component/ds/useSwitchChemelexUi';
import { useTranslation } from 'src/i18n';

/*
 * Per-user opt-out from the redesigned UI (ADR-00003 SD3).
 */
export default function ChemelexUiToggle () {
  const hasFeature = useSelector(hasChemelexUiFeature);
  const useChemelexUi = useSelector(getUseChemelexUiPreference);
  const switchChemelexUi = useSwitchChemelexUi();
  const { t } = useTranslation();

  // Facilities without the feature never see the option.
  if (!hasFeature) {
    return null;
  }

  const handleChange = (e) => {
    switchChemelexUi(e.target.checked);
  };

  return (
    <div className='chemelex-ui-toggle'>
      <h4>{t('profile.updatedView')}</h4>
      <FormGroup>
        <Switch
          checked={useChemelexUi !== false}
          onChange={handleChange}
          color='primary'
          title={t('profile.updatedViewDescription')}
          inputProps={{ 'aria-label': t('profile.updatedView') }}
        />
      </FormGroup>
    </div>
  );
}
